// Module
var code = `<div class="selection" data-bind="css: { expanded: expanded, disabled: disabled }, click: onComponentExpand">
    <span class="caption" data-bind="visible: selectedOptions().length === 0 && caption !== null,
                     text: caption"></span>
    <ul class="selected-options" data-bind="visible: selectedOptions().length > 0 || caption === null,
                   foreach: { data: selectedOptions, as: 'option' }">
        <li class="option" data-bind="css: { valid: option.valid(), 'not-valid': !option.valid() },
                                      click: function () {},
                                      clickBubble: false">
            <span class="label" data-bind="text: option.original[\$component.labelKey]"></span>
            <span class="remove icon_button icon_delete only_icon_img" data-bind="click: \$component.onUnselectOption, clickBubble: false"></span>
        </li>
    </ul>
    <div class="expander"></div>
</div>
<div class="expansion" data-bind="visible: expanded,
                css: { expanded: expanded(), overlay: displayStyle === 'overlay' }">
    <div class="groups-wrapper" data-bind="if: expanded, event: { scroll: onGroupsScroll }">
        <ul class="groups-list" data-bind="foreach: { data: scoop, as: 'entry' }">
            <!-- ko if: \$component.groupKey !== null && entry.group.label !== null -->
                <li class="group" data-bind="css: { expanded: entry.group.expanded },
                                             click: \$component.onGroupExpand.bind(null, entry.group, undefined)">
                    <input class="checkbox" type="checkbox" data-bind="visible: \$component.selectType !== 'single',
                                      checked: entry.group.allSelected(),
                                      click: \$component.toggleGroupSelect.bind(entry, entry.group),
                                      clickBubble: false">
                    <span class="label" data-bind="text: entry.group.label"></span>
                    <span class="meta" data-bind="text: entry.group.matchedOptionsLabel"></span>
                    <div class="expander"></div>
                </li>
            <!-- /ko -->
            <ul class="options" data-bind="foreach: { data: entry.options, as: 'option' }">
                <li class="option" data-bind="css: { selected: option.selected,
                                                     highlight: \$component.highlightedOption() === option },
                                              scrollToElement: { trigger: scrollTo,
                                                                 containerSelector: '.groups-wrapper' }">
                    <label class="label-wrap">
                        <input class="checkbox" data-bind="checked: option.selected,
                                                           checkedValue: true,
                                                           attr: { type: \$component.checkboxType,
                                                                   name: \$component.uniqueCheckboxName }">
                        <span class="label" data-bind="text: option.original[\$component.labelKey]"></span>
                        <span class="meta" data-bind="visible: option.original[\$component.metaKey],
                                                      text: option.original[\$component.metaKey]"></span>
                    </label>
                </li>
            </ul>
        </ul>
        <div class="scoop-more" data-bind="visible: visibleOptionsCount() > scoopLimit(),
                                           text: translated('more'),
                                           click: scoopMore"></div>
    </div>
    <div class="filter">
        <label style="display: none" data-bind="text: translated('Filter'),
                          attr: {for: ('filter_input_' + instanceNumber)}"></label>
        <input type="text" class="input" autocomplete="off" data-bind="hasFocus: hasFilterFocus,
                          event: { keydown: onFilterKeydown },
                          textInput: filter,
                          attr: {
                            id: ('filter_input_' + instanceNumber),
                            placeholder: translated('Filter'),
                          }">
        <button class="add" data-bind="text: translated('Add'),
                           enable: filter() && !filterInCustomOptions(),
                           visible: \$component.allowCustom,
                           click: onAddCustomFilter"></button>
    </div>
</div>
<!-- ko if: dummyName !== null && serializeKey !== null -->
<select class="dummy-select" data-bind="attr: { name: dummyName, multiple: selectType !== 'single' },
                                        foreach: { data: selectedOptions, as: 'option' }">
    <option selected="selected" data-bind="value: option.original[\$component.serializeKey],
                                           text: option.original[\$component.labelKey]"></option>
</select>
<!-- /ko -->
`;
// Exports
export default code;